import React, { Component } from 'react';
import { UniGrid } from '../UniGrid';
import Inline from '../Inline';
import { Button, Form, Popup, SelectBox, Template, TextBox } from 'devextreme-react';
import { ButtonItem, ButtonOptions, EmptyItem, SimpleItem } from 'devextreme-react/form';
import { style } from 'typestyle';
import { apiDeleteP, apiGetP, apiPostP } from '../../GanjiTools';

class UserManager extends Component {
    state = {
        potentialUsers: [],
        _potentialUser: {},
        _user: this.props.user ?? {
            // userName: '',
            // password:'',
            // linkedRecord_Table: '',
            // linkedRecord_RowId: null,
            role: 'guest',
        },
        containerKey: 1,
    }

    onClickAddUser = (role, linkedRecord_Table) => {
        this.setState({
            _user: {
                ...this.state._user,
                id: 0,
                linkedRecord_Table,
                linkedRecord_RowId: null,
                role: role ?? 'guest'
            },
            userPopVisible: true
        });
    }

    saveNewUsernamePsw = () => {
        if (!(this.state._newPsw_userId > 0)) {
            window.notif('کاربر نامشخص');
            return;
        }

        if (!(this.state._newUsername?.length > 0 && this.state._newPsw?.length > 0)) {
            window.notif('نام کاربری یا رمز نباید خالی باشد');
            return;
        }

        apiPostP(`/api/parssaman/changeUsernamePsw/${this.state._newPsw_userId}`, { u: this.state._newUsername, p: this.state._newPsw })
            .then(res => {
                const { error } = res ?? { error: 'No respnse.' };
                if (error?.length > 0) {
                    window.notif(error);
                    return;
                }
                this.setState({ _newPsw_userId: 0, _newPsw: '', _newUsername: '', containerKey: this.state.containerKey + 1, pswPopVisible: false });
            })
            .catch(window.notif);
    }

    saveUser = user => {
        if (!user) {
            user = { ...this.state._user };
            user.userName = `${this.state._user.userName}/role=${this.state._user.role ?? 'guest'}`
        }
        apiPostP('/api/parssaman/saveUser', user) // ?? { ...this.state._user, userName: `${this.state._user.userName}/role=${this.state._user.role ?? 'guest'}` })
            .then(res => {
                const { error } = res ?? { error: 'No respnse.' };
                if (error?.length > 0) {
                    window.notif(error);
                    return;
                }
                this.setState({ _user: {}, containerKey: this.state.containerKey + 1, userPopVisible: false });
            })
            .catch(window.notif);
    }

    loadPotentialUsers = () => {
        apiGetP('/api/parssaman/potentialUsers')
            .then(res => {
                const { error = 'Mo response.', list = [] } = res ?? {};
                if (error?.length > 0) {
                    window.notif(error);
                    return;
                }
                let potentialUsers = list.map(x => ({ ...x, summary: `${x.fName ?? ''} ${x.lName ?? ''} ${x.nationalCode ?? ''} ${x.tel?.length > 0 ? '☎ ' + x.tel : ''}` }));
                this.setState({ potentialUsers });
            }).catch(window.notif);
    }

    componentDidMount() {
        this.loadPotentialUsers();
        this.tinyFontClassName = style({ fontSize: '0.7rem' });
    }

    updateUser = (id, newData, oldData, onError) => {
        this.saveUser({ ...oldData, ...newData, id });
    }

    deleteUser = id => {
        apiDeleteP('/api/parssaman/removeUser/' + id)
            .then(res => {
                const { error = 'No response.' } = res ?? {};
                if (error?.length > 0) {
                    window.notif(error);
                    return;
                }
                this.setState({ containerKey: this.state.containerKey + 1 });
            }).catch(window.notif);
    }

    addUserButtonsList = (width = '12rem', vSpace = false) => [
        vSpace && <div style={{ height: '5px' }}></div>,
        <Button text='افزودن اپراتور' width={width} type='success' icon='plus' rtlEnabled
            onClick={() => this.onClickAddUser('اپراتور', '')}
        />, vSpace && <div style={{ height: '5px' }}></div>,
        <Button text='افزودن سهامدار' width={width} type='success' icon='plus' rtlEnabled
            onClick={() => this.onClickAddUser('سهامدار', 'shareholder')}
        />, vSpace && <div style={{ height: '5px' }}></div>,
        <Button text='افزودن مشتری' width={width} type='success' icon='plus' rtlEnabled
            onClick={() => this.onClickAddUser('مشتری', 'customer')}
        />, vSpace && <div style={{ height: '5px' }}></div>,
        <Button text='افزودن ماشین دار' width={width} type='success' icon='plus' rtlEnabled
            onClick={() => this.onClickAddUser('ماشین دار', 'truckowner')}
        />, vSpace && <div style={{ height: '5px' }}></div>,
        <Button text='افزودن راننده' width={width} type='success' icon='plus' rtlEnabled
            onClick={() => this.onClickAddUser('راننده', 'driver')}
        />, vSpace && <div style={{ height: '5px' }}></div>
    ]



    render() {
        if (window.user?.role !== 'ادمین')
            return (<p>کاربر غیرمجاز!</p>);

        return (
            <div style={{ padding: window.mView ? '0 5px' : '0 1rem' }} key={`cont_${this.state.containerKey}`}
            >
                <UniGrid url='/api/parssaman/users' allowAdding={false}
                    width={window.mView && '90vw'}
                    formColCount={window.mView ? 1 : undefined}
                    editFormProps={{ labelLocation: window.mView ? 'top' : 'left', width: window.mView ? '85vw' : undefined }}
                    pageSize={10}
                    hideFields={['id', 'linkedrecord_table', 'linkedrecord_rowid']}
                    onManualUpdateRow={this.updateUser} onManualDeleteRow={this.deleteUser}
                    modifyFields={{
                        role: { readOnly: true, caption: 'نقش' },
                        fname: { caption: 'نام' },
                        lname: { caption: 'نام خانوادگی' },
                        tel: { caption: 'تلفن' },
                        mobile: { caption: 'موبایل' },
                        email: { caption: 'ایمیل' },
                        username: { caption: 'نام کاربری', readOnly: true },
                        nationalcode: { caption: 'کد ملی' },
                    }}
                    buttonColumns={[
                        {
                            name: 'changeuserpass', caption: 'تغییر رمز', icon: 'lock', width: '5rem',
                            onClick: u => this.setState({ _newPsw_userId: u.id, _newUsername: u.username, pswPopVisible: true })
                        }
                    ]}
                />

                {window.mView ?
                    <div>
                        {this.addUserButtonsList('100%', true)}
                    </div>
                    :
                    <Inline spacing='5px' style={{ marginTop: '2rem', justifyContent: 'center' }}>
                        {...this.addUserButtonsList()}
                    </Inline>
                }

                {/* {false &&
                    <Inline spacing='5px' style={{ marginTop: '2rem', justifyContent: 'center' }}>
                        <Button text='افزودن اپراتور' width='12rem' type='success' icon='plus' rtlEnabled
                            onClick={() => this.onClickAddUser('اپراتور', '')}
                        />
                        <Button text='افزودن سهامدار' width='12rem' type='success' icon='plus' rtlEnabled
                            onClick={() => this.onClickAddUser('سهامدار', 'shareholder')}
                        />
                        <Button text='افزودن مشتری' width='12rem' type='success' icon='plus' rtlEnabled
                            onClick={() => this.onClickAddUser('مشتری', 'customer')}
                        />
                        <Button text='افزودن ماشین دار' width='12rem' type='success' icon='plus' rtlEnabled
                            onClick={() => this.onClickAddUser('ماشین دار', 'truckowner')}
                        />
                        <Button text='افزودن راننده' width='12rem' type='success' icon='plus' rtlEnabled
                            onClick={() => this.onClickAddUser('راننده', 'driver')}
                        />
                    </Inline>
                } */}

                <Popup rtlEnabled title={' کاربر با نقش ' + (this.state._user.role ?? '')} visible={this.state.userPopVisible}
                    //key={'pop_' + this.state.containerKey}
                    onHiding={() => this.setState({ userPopVisible: false })} height='auto' width={window.mView ? '95vw' : 'auto'}
                //className={'mdh-pop-edit-user ' + style({ padding: window.mView ? '5px' : '3rem' })}
                >
                    <Form colCount={60} width={window.mView ? '80vw' : '50rem'}
                        labelLocation={window.mView ? 'top' : 'left'}
                    >
                        {this.state._user.role !== 'اپراتور' &&
                            <SimpleItem colSpan={60}>
                                <SelectBox rtlEnabled
                                    dataSource={this.state.potentialUsers.filter(x => x.role === this.state._user.role)}
                                    valueExpr='id' displayExpr='summary'
                                    value={this.state._potentialUserId}
                                    onValueChanged={e => {
                                        const _potentialUser = this.state.potentialUsers.find(x => x.id == e.value) ?? {};
                                        this.setState({
                                            _potentialUserId: e.value,
                                            _potentialUser,
                                            _user: { ..._potentialUser, ...this.state._user, linkedRecord_RowId: (e.value ?? 0) % 1000000 },
                                        });
                                    }}
                                />
                            </SimpleItem>
                        }
                        {this.state._user.role !== 'اپراتور' &&
                            <SimpleItem colSpan={60}>
                                <Inline spacing='5px'>
                                    <label className={this.tinyFontClassName}>پیشنهاد نام کاربری : </label>
                                    {this.state._potentialUser.lName?.length > 0 &&
                                        <Button stylingMode='text' text={'نام خانوادگی: ' + this.state._potentialUser.lName}
                                            className={this.tinyFontClassName}
                                            onClick={() => this.setState({ _user: { ...this.state._user, userName: this.state._potentialUser.lName } })}
                                        />
                                    }
                                    {this.state._potentialUser.nationalCode?.length > 0 &&
                                        <Button stylingMode='text' text={'کد ملی: ' + this.state._potentialUser.nationalCode}
                                            className={this.tinyFontClassName}
                                            onClick={() => this.setState({ _user: { ...this.state._user, userName: this.state._potentialUser.nationalCode } })}
                                        />
                                    }
                                    {this.state._potentialUser.tel?.length > 0 &&
                                        <Button stylingMode='text' text={'موبایل : ' + this.state._potentialUser.tel}
                                            className={this.tinyFontClassName}
                                            onClick={() => this.setState({ _user: { ...this.state._user, userName: this.state._potentialUser.tel } })}
                                        />
                                    }
                                </Inline>
                            </SimpleItem>
                        }

                        <SimpleItem colSpan={window.mView ? 60 : 30} label={{ text: 'نام کاربری' }}>
                            <TextBox readOnly={this.state._user?.id > 0}
                                value={this.state._user.userName ?? ''}
                                onValueChanged={e => this.setState({ _user: { ...this.state._user, userName: e.value } })}
                            />
                        </SimpleItem>

                        <SimpleItem colSpan={window.mView ? 60 : 30} label={{ text: 'رمز' }}>
                            <TextBox value={this.state._user.password ?? ''}
                                onValueChanged={e => this.setState({ _user: { ...this.state._user, password: e.value } })}
                            />
                        </SimpleItem>

                        <EmptyItem colSpan={60} />

                        <ButtonItem colSpan={window.mView ? 60 : 12}>
                            <ButtonOptions text='ذخیره' width={window.mView ? '100%' : '10rem'} type='success' onClick={() => this.saveUser()}
                            />
                        </ButtonItem>

                        <ButtonItem colSpan={window.mView ? 60 : 12}>
                            <ButtonOptions text='انصراف' width={window.mView ? '100%' : '10rem'} onClick={() => this.setState({ _user: {}, userPopVisible: false })}
                                type='danger'
                            />
                        </ButtonItem>
                    </Form>
                </Popup>

                <Popup rtlEnabled title={' تغییر رمز ' + (this.state._user.summary ?? '')} visible={this.state.pswPopVisible}
                    //key={'pop_' + this.state.containerKey}
                    onHiding={() => this.setState({ pswPopVisible: false })} height='auto' width={window.mView ? '95vw' : '40rem'}
                    className={style({ padding: '3rem' })}
                >
                    <Form rtlEnabled colCount={60} //width={window.mView && '100vw'}
                    >
                        <SimpleItem colSpan={window.mView ? 60 : 30} label={{ text: 'نام کاربری', location: window.mView ? 'top' : 'left' }}>
                            <TextBox rtlEnabled
                                value={this.state._newUsername}
                                onValueChanged={e => this.setState({ _newUsername: e.value })}
                            />
                        </SimpleItem>

                        <SimpleItem colSpan={window.mView ? 60 : 30} label={{ text: 'رمز' }}>
                            <TextBox rtlEnabled
                                value={this.state._newPsw}
                                onValueChanged={e => this.setState({ _newPsw: e.value })}
                            />
                        </SimpleItem>

                        <EmptyItem colSpan={60} />

                        <ButtonItem colSpan={window.mView ? 60 : 30}>
                            <ButtonOptions text='ذخیره' width={window.mView ? '100%' : '10rem'} type='success' onClick={() => this.saveNewUsernamePsw()}
                            />
                        </ButtonItem>

                        <ButtonItem colSpan={window.mView ? 60 : 30}>
                            <ButtonOptions text='انصراف' width={window.mView ? '100%' : '10rem'} onClick={() => this.setState({ _newPsw: '', pswPopVisible: false })}
                                type='danger'
                            />
                        </ButtonItem>

                    </Form>
                </Popup>

            </div>
        );
    }
}

export default UserManager;